module.exports = __webpack_public_path__ + "img/doctor.a7cac922.webp";